import { type HTMLAttributes, type ReactNode } from 'react';

import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import styles from './ViewItem.module.scss';
import { type IconButtonProps, IconButton } from '@/components/ui/IconButton';
import { uiIcons } from '@/constants/uiIcons';

interface ViewItemProps extends HTMLAttributes<HTMLDivElement> {
  actions?: ReactNode;
}

export const ViewItem = ({
  children,
  actions,
  className,
  ...props
}: ViewItemProps) => (
  <div
    data-view-item
    data-view-item-has-actions={!!actions || undefined}
    className={cx(styles.ViewItem, className)}
    {...props}
  >
    {children}
    {!!actions && <div className={styles.Actions}>{actions}</div>}
  </div>
);

type ViewActionsButtonProps = Omit<
  Extract<IconButtonProps, { component?: 'button' | undefined }>,
  'size' | 'iconName' | 'tooltip'
>;

export const ViewActionsButton = ({
  className,
  ...props
}: ViewActionsButtonProps) => {
  const { t } = useTranslation('views');
  return (
    <IconButton
      size="tiny"
      iconName={uiIcons.controls.moreOptionsVertical}
      tooltip={t('Actions')}
      aria-haspopup="true"
      data-automation-id="views-action-button"
      className={cx(styles.ViewActionsButton, className)}
      {...props}
    />
  );
};
